fragment HeaderFieldFragment on HeaderField {
    type
    isEnabled
    name
}
